'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { dataAttr, cx } from '@chakra-ui/utils';
import { useButtonGroup } from './button-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { useStyleConfig } from '../system/use-style-config.mjs';
import { chakra } from '../system/factory.mjs';

const Button = forwardRef((props, ref) => {
  const group = useButtonGroup();
  const styles = useStyleConfig("Button", { ...group, ...props });
  const {
    isDisabled = group?.isDisabled,
    isActive,
    type,
    className,
    as,
    ...rest
  } = omitThemingProps(props);
  return /* @__PURE__ */ jsx(
    chakra.button,
    {
      ref,
      as,
      type: "button",
      "data-in-group": dataAttr(!!group),
      "data-active": dataAttr(isActive),
      __css: styles,
      disabled: isDisabled,
      ...rest,
      className: cx("chakra-button", className)
    }
  );
});
Button.displayName = "Button";

export { Button };
